import { Component, Input } from '@angular/core';
import { Role, Roles } from 'src/app/shared/data/roles';

@Component({
  selector: 'user-role-renderer',
  template: `
    <span>
      {{ getRoleName(rowData?.RoleId) }}
    </span>
  `,
  standalone: true,
})
export class UserRoleRenderer {
  @Input() rowData: any;

  getRoleName(roleId: number): string {
    const role = Roles.find((r) => r.Id === roleId);
    return role ? role.Name : '';
  }
}
